var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.annotations),function(annotation){return _c('annotation',_vm._b({key:annotation.id,attrs:{"parent":_vm.object}},'annotation',annotation,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }